import { createContext } from 'preact';
const CloseableContext = createContext({});
export default CloseableContext;
//# sourceMappingURL=CloseableContext.js.map